// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `textarea {
  resize: none;
  outline: none;
  width: 90%;
}

div.align-right {
  text-align: right;
}

.spacer {
  padding-top: 10px;
  padding-bottom: 20px;
}

.capitalize {
  text-transform: capitalize;
}

.attachment-link {
  color: #007bff;
  text-decoration: none;
  cursor: pointer;
}
.attachment-link:hover {
  color: #0056b3;
  text-decoration: underline;
}

.file-item {
  margin-bottom: 5px;
}
.file-item small {
  cursor: pointer;
  color: #007bff;
}
.file-item small:hover {
  color: #0056b3;
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./projects/eCash/src/app/manage-request/request-details-view/request-details-view.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,aAAA;EACA,UAAA;AACJ;;AAEA;EACI,iBAAA;AACJ;;AAEA;EACI,iBAAA;EACA,oBAAA;AACJ;;AAEA;EACI,0BAAA;AACJ;;AAEA;EACI,cAAA;EACA,qBAAA;EACA,eAAA;AACJ;AACI;EACI,cAAA;EACA,0BAAA;AACR;;AAEA;EACI,kBAAA;AACJ;AACI;EACI,eAAA;EACA,cAAA;AACR;AACQ;EACI,cAAA;EACA,0BAAA;AACZ","sourcesContent":["textarea {\n    resize: none;\n    outline: none;\n    width: 90%;\n}\n\ndiv.align-right {\n    text-align: right;\n}\n\n.spacer {\n    padding-top: 10px;\n    padding-bottom: 20px\n}\n\n.capitalize {\n    text-transform: capitalize;\n}\n\n.attachment-link {\n    color: #007bff;\n    text-decoration: none;\n    cursor: pointer;\n    \n    &:hover {\n        color: #0056b3;\n        text-decoration: underline;\n    }\n}\n.file-item {\n    margin-bottom: 5px;\n    \n    small {\n        cursor: pointer;\n        color: #007bff;\n        \n        &:hover {\n            color: #0056b3;\n            text-decoration: underline;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
